// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import BannerManager from "../../components/dashboard/BannerManager";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <BannerManager />
    </DashboardLayout>
  );
}
